<template>
  <v-card>

    <v-card-title>
      {{ $t('rights.addForm.spotifyTitle') }}
    </v-card-title>

    <v-card-text>

      <v-card v-if="useDnD" flat class="droparea"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        :class="{ 'grey lighten-2': dragover }">
        <v-card-text class="d-flex flex-column align-center justify-center">
          <v-icon size="80" class="mb-4">mdi-spotify</v-icon>
          <p class="text-subtitle-1 mb-0 text-center">{{ $t('rights.addForm.drop_links_here') }}</p>
        </v-card-text>
      </v-card>

      <v-text-field v-else
        v-model="linkInput"
        :label="$t('rights.addForm.paste_link_label')"
        :placeholder="$t('rights.addForm.paste_link_placeholder')"
        append-icon="mdi-plus"
        @click:append="addLink"
        @keyup.enter="addLink"
        clearable
        outlined
      />

      <v-virtual-scroll
        v-if="spotifyLinks.length > 0"
        :items="spotifyLinks"
        height="200"
        item-height="50"
        class="mt-2"
      >
        <template v-slot:default="{ item }">
          <v-list-item :key="item">
            <v-list-item-content>
              <v-list-item-title>{{ item }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn @click.stop="removeLink(item)" icon>
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
        </template>
      </v-virtual-scroll>

      <div class="d-flex mt-1">
        <v-spacer></v-spacer>
        <span v-if="spotifyLinks.length" class="caption">
          {{ spotifyLinks.length + ' ' + $t('rights.addForm.num_links') }}
        </span>
      </div>

    </v-card-text>

    <v-card-actions>
      <v-btn text @click="switchMode">
        {{ useDnD ? $t('rights.addForm.switchToPaste') : $t('rights.addForm.switchToDnD') }}
      </v-btn>
      <v-spacer/>
      <v-btn text color="primary" @click="onSave" :disabled="!spotifyLinks.length">{{ $t('rights.addForm.save') }}</v-btn>
      <v-btn text @click="cancel">{{ $t('app.cancel') }}</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>

export default {
  name: "AddRightSpotifyForm",
  data() {
    return {
      useDnD: true,
      dragover: false,
      linkInput: '',
      spotifyLinks: []
    }
  },

  mounted() {
    this.useDnD = !this.$vuetify.breakpoint.mobile;
  },

  methods: {

    onSave() {
      this.$emit('save', this.spotifyLinks)
    },

    cancel() {
      this.$emit('cancel');
    },

    removeLink(link) {
      const index = this.spotifyLinks.findIndex(e => e === link)
      if (index > -1) this.spotifyLinks.splice(index, 1)
    },

    addLink() {
      const validRe = /^https:\/\/open.spotify.com\//i;
      const link = this.linkInput.trim();
      if (validRe.test(link) && !this.spotifyLinks.includes(link)) {
        this.spotifyLinks.push(link);
        this.linkInput = '';
      }
    },

    switchMode() {
      this.useDnD = !this.useDnD;
      this.linkInput = '';
    },

    onDrop(e) {
      this.dragover = false;
      try {
        const links = e.dataTransfer.getData("text").split('\n')
        const validRe = /^https:\/\/open.spotify.com\//i
        links.forEach(element => {
          if (validRe.test(element)) {
            this.spotifyLinks.push(element)
          }
        })
      } catch (error) {
        //
      }
    }
  }
}
</script>

<style scoped>
.droparea {
  min-height: 200px !important;
  background-color: var(--color-surface-dim) !important;
}
</style>
